import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { HelpModalComponent } from './help-modal.directive';

@Component({
  selector: 'h3-vector-tagging-help-modal',
  templateUrl: './help-modal.directive.html',
  styleUrls: ['./help-modal.directive.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VectorTaggingHelpModalComponent
  extends HelpModalComponent
  implements OnInit
{
  ngOnInit() {
    this.config = {
      tabs: [
        {
          name: 'Vector',
          sections: [
            this.getGeneralSection(),
            this.getToolsSection(),
            this.getEditSection(),
          ],
        },
      ],
    };
  }

  protected override getViewSettingsShortcuts() {
    return [
      ...super.getViewSettingsShortcuts(),
      ...this.getBrightnessAndContrastShortcuts(),
    ];
  }

  protected override getEditShortcuts() {
    return [
      ...this.getCopyShortcuts(),
      ...super.getEditShortcuts(),
      ...this.getMovementShortcuts(),
      { name: 'Redraw selected shape', key: this.shortcut('redraw') },
    ];
  }

  protected getCopyShortcuts() {
    return [
      {
        name: 'Copy selected shapes',
        key: this.shortcut('copySelectedShapes'),
      },
    ];
  }

  protected getAnnotationToolsShortcuts() {
    return [
      { name: 'Select tool', key: this.shortcut('selectSelectTool') },
      { name: 'Edit tool', key: this.shortcut('selectEditTool') },
      { name: 'Point tool', key: this.shortcut('selectPointTool') },
      { name: 'Line tool', key: this.shortcut('selectLineTool') },
      { name: 'Arrow tool', key: this.shortcut('selectArrowTool') },
      { name: 'Rectangle tool', key: this.shortcut('selectRectangleTool') },
      {
        name: 'Slider rectangle tool',
        key: this.shortcut('selectSliderRectangleTool'),
      },
      { name: 'Polygon tool', key: this.shortcut('selectPolygonTool') },
      { name: 'Cuboid tool', key: this.shortcut('selectCuboidTool') },
      { name: 'Keypoint tool', key: this.shortcut('selectKeypointTool') },
      { name: 'Measure tool', key: this.shortcut('selectMeasureTool') },
      { name: 'Zoom tool', key: this.shortcut('selectZoomTool') },
    ];
  }

  protected override getLayerViewSettingsShortcuts() {
    if (!this.isViewSettingsShortcutsOn) {
      return [
        { name: 'View all', key: '1' },
        { name: 'View selected', key: '2' },
        { name: 'View none', key: '3' },
      ];
    }
    return super.getLayerViewSettingsShortcuts();
  }

  protected getNavigationShortcuts() {
    return [
      { name: 'Pan', key: this.panShortcut },
      { name: 'Zoom', key: 'SCROLL' },
      { name: 'Reset zoom', key: '0' },
      {
        name: 'Toggle zoom panel',
        key: this.shortcut('toggleZoomPanel'),
      },
    ];
  }

  private getGeneralSection() {
    return {
      name: 'General',
      shortcuts: [
        ...this.getViewSettingsShortcuts(),
        ...this.getLayerViewSettingsShortcuts(),
        ...this.getInspectModeShortcut(),
        ...this.getUndoRedoShortcuts(),
        ...this.getNavigationShortcuts(),
      ],
    };
  }

  private getToolsSection() {
    return {
      name: 'Tools',
      shortcuts: this.getAnnotationToolsShortcuts(),
    };
  }

  private getEditSection() {
    return {
      name: 'Edit',
      shortcuts: [
        ...this.getEditShortcuts(),
        ...this.getDeleteSubpointsShortcut(),
      ],
    };
  }
}
